module.exports = __webpack_public_path__ + "img/cabin-side.eab98672.jpg";